import { render, staticRenderFns } from "./AddAssetTypeModal.vue?vue&type=template&id=4ccc5fb7&scoped=true&"
import script from "./AddAssetTypeModal.vue?vue&type=script&lang=js&"
export * from "./AddAssetTypeModal.vue?vue&type=script&lang=js&"
import style0 from "./AddAssetTypeModal.vue?vue&type=style&index=0&id=4ccc5fb7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ccc5fb7",
  null
  
)

export default component.exports